import { makeAutoObservable } from 'mobx';
import { PasswordDetailInterface } from '../../interfaces/AuthInterface';
import { DefaultPasswordDetail } from '../common';
import { InvoicingDetailsInterface, ProfileDataInterface } from '../../interfaces/SettingsInterface';

export class SettingStore {
  passwordDetail: PasswordDetailInterface = DefaultPasswordDetail;
  invoicingDetail: InvoicingDetailsInterface | null = null;
  profileData: ProfileDataInterface | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Update specific password field
  updatePasswordDetail(propsName: string, value: string) {
    this.passwordDetail = {
      ...this.passwordDetail,
      [propsName]: value
    };
  }

  setInvoicingDetail(invoicingDetail: InvoicingDetailsInterface) {
    this.invoicingDetail = invoicingDetail;
  }

  // Update invoice details
  updateInvoicingDetail(propsName: string, value: string | number | { name: string; value: string }[]) {
    if (this.invoicingDetail) {
      this.invoicingDetail = {
        ...this.invoicingDetail,
        [propsName]: value
      };
    }
  }

  //Set user profile data
  setProfileData(profileData: ProfileDataInterface) {
    this.profileData = profileData;
  }

  // Update invoice details
  updateProfileData(propsName: string, value: string | number | { name: string; value: string }[]) {
    if (this.profileData) {
      this.profileData = {
        ...this.profileData,
        [propsName]: value
      };
    }
  }

  // Clear password related data
  clearSettingData() {
    this.passwordDetail = DefaultPasswordDetail;
    this.invoicingDetail = null;
  }
}
